import { useLang } from '@/i18n';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import css from './index.module.scss';

const A: React.FC = () => {
    const { t } = useLang('stream.overview');
    return (
        <div className={`${css.section} stream-nl-A GtmModuleData-section`} id="stream-nl-A" data-section-id={'stream-nl-A'}>
            <EcoImg
                className="banner-img"
                pc="https://websiteoss.ecoflow.com/upload/image/1775027013491/a1.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1775027026859/a1m.jpg"
                alt={t('A_title')}
            />
            <div className="banner-info">
                <p className="banner-subtitle">{t('A_subtitle')}</p>
                <h1 className="banner-title">{t('A_title')}</h1>
                <EcoLink href="https://nl.ecoflow.com/products/stream-thuisbatterij" className="banner-btn">
                    {t('A_btn')}
                </EcoLink>
            </div>
        </div>
    );
};

export default A;
